import SimulationFlow from "./SimulationFlow.mjs";
import Glob from "../../../libs/Glob.mjs";

const SimulationFlowNew = class extends SimulationFlow {
	componentDidMount() {
		super.componentDidMount();
		if ( this.state.step !== 'info' ) Glob.setCurrentPageParam('step','info');
	}
};

export default SimulationFlowNew;
